import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FailedPaymentsRestrictedComponent } from './failed-payments-restricted.component';
import { FailedPaymentsRoutingModule } from './failed-payments.routing';
import { FailedPaymentsService } from './failed-payments.service';

@NgModule({
  declarations: [FailedPaymentsRestrictedComponent],
  imports: [
    MatDialogModule,
    MatButtonModule,
    RouterModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    CommonModule,
    FailedPaymentsRoutingModule,
    MatCardModule,
    TranslateModule,
  ],
  exports: [FailedPaymentsRestrictedComponent],
  providers: [FailedPaymentsService],
})
export class FailedPaymentsModule {}
